<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<h1 mat-dialog-title>
  <ng-container i18n="@@app.dialogs.shareDialog.title"
    >Add survey participants</ng-container
  >
</h1>

<div mat-dialog-content>
  <form
    class="share-form"
    [formGroup]="addUserForm"
    (ngSubmit)="onAddUserSubmit()"
  >
    <mat-form-field class="email-input">
      <mat-label i18n="@@app.forms.labels.emailAddress"
        >Email address</mat-label
      >
      <input matInput formControlName="email" autocomplete="off" />
      @if (emailControl.touched && emailControl.invalid) {
        @if (emailControl.getError('email')) {
          <mat-error i18n="@@app.controls.errors.invalidEmailFormat"
            >Invalid email format</mat-error
          >
        }
        @if (emailControl.getError('emailAlreadyAdded')) {
          <mat-error i18n="@@app.controls.errors.emailAlreadyAdded"
            >Email address already added</mat-error
          >
        }
      }
    </mat-form-field>
    <mat-form-field>
      <mat-select formControlName="role">
        @for (option of roleOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    <ng-container i18n="@@app.labels.cancel">Cancel</ng-container>
  </button>

  <button
    mat-flat-button
    color="primary"
    [disabled]="addUserForm.value['email'] === '' || !addUserForm.valid"
    (click)="onAddUserSubmit()"
  >
    <ng-container i18n="@@app.labels.send">Send</ng-container>
  </button>
</div>
